import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import myTheme from "../../common/DataGrid/ag-grid-theme-builder";

const columnDefs = [
  {
    field: "danger_category",
    headerName: "위험분류",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
  },
  {
    field: "danger_cause",
    headerName: "위험요인",
    flex: 1,
    minWidth: 140,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
  },
  {
    field: "danger_description",
    headerName: "위험요인 발생상황 및 결과",
    flex: 1,
    minWidth: 280,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
  },
  {
    field: "eval_risk_level",
    headerName: "위험성평가",
    flex: 1,
    minWidth: 60,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    valueFormatter: (params) => {
      const level = params.value;
      switch (level) {
        case 1: return "하";
        case 2: return "중";
        case 3: return "상";
        default: return "-";
      }
    }
  },
  {
    field: "improve_plan",
    headerName: "개선대책",
    flex: 1,
    minWidth: 200,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    valueFormatter: (params) => {
      return params.value ? params.value : '-';
    }
    //sort: 'asc',
  },
  {
    field: "improve_risk_level",
    headerName: "개선대책 후 위험성평가",
    flex: 1,
    minWidth: 60,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    valueFormatter: (params) => {
      const level = params.value;
      switch (level) {
        case 1: return "하";
        case 2: return "중";
        case 3: return "상";
        default: return "-";
      }
    }
  },
  {
    field: "emp_name",
    headerName: "작업자",
    flex: 1,
    minWidth: 80,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    valueFormatter: (params) => {
      return params.value ? params.value : '-';
    }
  },
  {
    field: "eval_status",
    headerName: "평가상태",
    flex: 1,
    minWidth: 60,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    valueFormatter: (params) => {
      let text = '-';
      if(params.value === 10) { text = '평가완료'; }
      else if (params.value === 20) { text = '승인완료'; }

      return text;
    }
  },
  {
    field: "improve_status",
    headerName: "대책상태",
    flex: 1,
    minWidth: 60,
    headerClass: "ag-header-center",
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    valueFormatter: (params) => {
      let text = '-';
      if(params.value === 10) { text = '대책 등록완료'; }
      //else if(params.value === 20) { text = '일정 등록완료'; }
      else if(params.value === 20) { text = '개선완료'; }

      return text;
    }
  },
];

function RiskListModal({ open, onClose, data, assetInfo }) {
  const gridOptions = {
    pagination: true,
    paginationPageSize: 20,
    rowHeight: 52,
    headerHeight: 52,
    suppressCellFocus: true,
    defaultColDef: {
      sortable: true,
      filter: false,
      resizable: true,
    },
    suppressMenuHide: true,
    suppressContextMenu: true,
    enableCellTextSelection: false,
  };

  const handleDialogClose = (event) => {
    event.stopPropagation();
    onClose();
  };
  
  return (
    <>
      <Dialog
        fullWidth
        open={open}
        maxWidth="lg"
        scroll="body"
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            onClose();
          }
        }}
        sx={{
          "& .MuiDialog-paper": {
            overflow: "visible",
            backgroundColor: "rgba(47, 51, 73, 0.8);",
            border: "solid 2px rgb(63 68 99)",
          },
        }}
      >
        <Box
          sx={{
            borderBottom: "solid 1px #464646;",
            padding: "16px 24px",
          }}
        >
          <Typography variant="h3" sx={{ color: "#ced4da" }}>
            위험성 평가 목록 - {assetInfo}
          </Typography>
        </Box>
        <DialogContent
          sx={{
            px: (theme) => [
              `${theme.spacing(5)} !important`,
              `${theme.spacing(10)} !important`,
            ],
            py: (theme) => [
              `${theme.spacing(8)} !important`,
              `${theme.spacing(10)} !important`,
            ],
          }}
        >
          <div style={{ height: '500px', width: '100%' }}>
            <AgGridReact
              rowData={data}
              columnDefs={columnDefs}
              gridOptions={gridOptions}
              theme={myTheme}
              suppressFiltersToolPanel={true}
              suppressColumnFilter={true}
              suppressRowClickSelection={true}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RiskListModal;
